import type { ReviewMode } from './types';

export const MODEL_REVIEW_ENDPOINTS = {
  models: '/api/model-review/models',
  prompts: '/api/model-review/prompts',
  templates: '/api/model-review/templates',
  generate: '/api/model-review/generate',
  evaluate: '/api/model-review/evaluate',
  sessions: '/api/sessions/recent',
} as const;

export interface GenerateRequest {
  session_id: string;
  models: string[];
  mode: ReviewMode;
  prompt: string;
  max_tokens: number;
  language: string;
  template_id?: number;
}

export interface EvaluateRequest {
  transcript: string;
  summaries: { model: string; summary: string | null }[];
  prompt_used: string;
  judge_model: string;
  language: string;
  session_id: string;
}

export const buildGenerateBody = (input: {
  sessionId: string;
  models: string[];
  mode: ReviewMode;
  prompt: string;
  maxTokens: number;
  templateId: number | null;
  language: string;
}): GenerateRequest => ({
  session_id: input.sessionId,
  models: input.models,
  mode: input.mode,
  prompt: input.prompt,
  max_tokens: input.maxTokens,
  language: input.language,
  ...(input.templateId ? { template_id: input.templateId } : {}),
});

export const buildEvaluateBody = (input: {
  sessionId: string;
  transcript: string;
  promptUsed: string;
  judgeModel: string;
  language: string;
  results: { model: string; summary: string | null; error: string | null }[];
  catalog: { id: string; name: string }[];
}): EvaluateRequest => ({
  transcript: input.transcript,
  prompt_used: input.promptUsed,
  judge_model: input.judgeModel,
  language: input.language,
  session_id: input.sessionId,
  summaries: input.results
    .filter((r) => r.summary && !r.error)
    .map((r) => ({
      model: input.catalog.find((m) => m.id === r.model)?.name ?? r.model,
      summary: r.summary,
    })),
});
